import { gql } from "@apollo/client";

export const REMOVE_ALIAS = gql`
  mutation removeAlias($input: RemoveAliasInput!) {
    removeAlias(input: $input) {
      clientMutationId
      errors
      success
    }
  }
`;
